import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserIdleModule } from 'angular-user-idle';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DeleteModalDialogComponent } from './components/dialog/delete-modal-dialog.component';
import { PepMessageDialogComponent } from './components/dialog/pep-message-dialog.component';
import { ServiceModeModalDialogComponent } from './components/dialog/service-mode-modal-dialog.component';
import { ErrorIconComponent } from './components/error/error-icon.component';
import { LoginComponent } from './components/login/login.component';
import { MainContentComponent } from './components/main-content/main-content.component';
import { TerminalsActionsComponent } from './components/nav-menu/actions/terminals-actions.component';
import { NavTrailComponent } from './components/nav-menu/navtrail.component';
import { StatusComponent } from './components/status/status.component';
import { TerminalListComponent } from './components/terminals/terminal-list/terminal-list.component';
import { TerminalComponent } from './components/terminals/terminal/terminal.component';
import { TerminalsDefaultComponent } from './components/terminals/terminals-default/terminals-default.component';
import { TerminalsComponent } from './components/terminals/terminals.component';
import { UnsavedModalDialogComponent } from './components/unsaved-modal-dialog/unsaved-modal-dialog.component';
import { UploadProtocolModalDialogComponent } from './components/upload/protocol-modal-dialog.component';
import { UploadSetupModalDialogComponent } from './components/upload/upload-modal-dialog.component';
import { UploadProtocolDetailsComponent } from './components/upload/upload-protocol-details.component';
import { AuthGuard } from './services/auth-guard.service';
import { CanDeactivateTerminalGuard } from './services/can-deactivate-terminal.guard';
import { FileUploadEndpointService } from './services/fileupload-endpoint.service';
import { FileUploadService } from './services/fileupload.service';
import { ProgramInfoEndpointService } from './services/programInfo-endpoint.service';
import { ProgramInfoService } from './services/programInfo.service';
import { ShopEndpointService } from './services/shop-endpoint.service';
import { ShopService } from './services/shop.service';
import { TerminalsEndpointService } from './services/terminals-endpoint.service';
import { TerminalsService } from './services/terminals.service';
import { APP_ID } from '@angular/core';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TerminalsComponent,
    TerminalComponent,
    TerminalListComponent,
    MainContentComponent,
    TerminalsActionsComponent,
    NavTrailComponent,
    TerminalsDefaultComponent,
    DeleteModalDialogComponent,
    PepMessageDialogComponent,
    ErrorIconComponent,
    StatusComponent,
    UnsavedModalDialogComponent,
    ServiceModeModalDialogComponent,
    UploadProtocolModalDialogComponent,
    UploadProtocolDetailsComponent,
    UploadSetupModalDialogComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    UserIdleModule,
    MatSortModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatFormFieldModule,
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatDividerModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    AppRoutingModule
  ],
  providers: [
    [{ provide: APP_ID, useValue: 'ng-cli-universal' }],
    TerminalsEndpointService,
    TerminalsService,
    ShopService,
    ShopEndpointService,
    CanDeactivateTerminalGuard,
    AuthGuard,
    ProgramInfoEndpointService,
    ProgramInfoService,
    FileUploadEndpointService,
    FileUploadService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
  }
}
